import React, { memo, useMemo } from 'react'
import tw from 'twin.macro'
import { DateTime } from 'luxon'
import { addS } from 'src/utils/baseUtils'
import { colors } from 'src/theme'
import { Typography } from '@mui/material'
import { MCDetails } from 'src/interfaces/mc'

interface Props {
  mcDetails: MCDetails
}

const MCPendingStepComponent = ({ mcDetails }: Props) => {
  const lastUpdateIn = useMemo(() => {
    return Math.round(DateTime.now().diff(DateTime.fromISO(mcDetails.inviteDate), 'days').days)
  }, [mcDetails.inviteDate, mcDetails])

  return (
    <div css={tw`bg-white rounded-2xl mb-6 px-[24px] py-4 text-center`}>
      <div css={tw`grid grid-cols-2 gap-4 items-end`}>
        <div>
          <Typography color={colors.GRAY_COOL_GRAY} css={tw`mb-1`} variant="h6">
            Date of invitation
          </Typography>
          <Typography color="black" variant="body2">
            {DateTime.fromISO(mcDetails.inviteDate).toFormat('LLL dd, yyyy')}
          </Typography>
        </div>
        <div>
          <Typography color={colors.GRAY_COOL_GRAY} css={tw`mb-1`} variant="h6">
            Last activity
          </Typography>
          <Typography color="black" variant="body2">
            {lastUpdateIn ? `${lastUpdateIn} ${addS(lastUpdateIn, 'day')} ago` : 'Today'}
          </Typography>
        </div>
      </div>
    </div>
  )
}

export const MCPendingStep = memo(MCPendingStepComponent)
